var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileNotificationSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 371.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6d8e5;opacity:0.4;}.cls-2{fill:#b1b4c4;}.cls-3{fill:#616e84;}.cls-4{fill:#757b89;}.cls-5{fill:#20232d;}.cls-6,.cls-9{fill:#fff;}.cls-7{opacity:0.5;fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15);}.cls-8{fill:#2b303f;}.cls-9{opacity:0.1;}.cls-10{fill:#e9eaf2;}.cls-11{fill:#dadce5;}.cls-12{fill:#edeef7;}.cls-13{fill:#f8f9ff;}.cls-14{fill:#ff5757;}.cls-15{opacity:0.05;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15",
    x1: 260.38,
    y1: 338.26,
    x2: 260.38,
    y2: 78.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mobile_notification_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.79,367.72l-124.66-72c-10.56-6.09-9.24-16.74,3-23.78L311.22,98.1c12.2-7,30.64-7.81,41.2-1.71l124.66,72c10.56,6.1,9.23,16.75-3,23.79L173,366C160.79,373.05,142.35,373.81,131.79,367.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.58,358.24l-124.66-72c-10.56-6.1-9.23-16.75,3-23.79L327,88.62c12.2-7,30.64-7.8,41.2-1.71l124.66,72c10.56,6.09,9.24,16.74-3,23.78L188.78,356.53C176.58,363.57,158.14,364.34,147.58,358.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.79 275.79 15.79 264.31 29.25 269.39 15.79 275.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "500 168.83 500 157.79 489.29 164.69 500 168.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.58,348.53l-124.66-72c-10.56-6.09-9.23-16.74,3-23.78L327,78.91c12.2-7,30.64-7.81,41.2-1.71l124.66,72c10.56,6.1,9.24,16.75-3,23.79L188.78,346.82C176.58,353.86,158.14,354.62,147.58,348.53Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 36.82,
    cy: 289.29,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-139.72 57.17) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 42.82,
    cy: 292.75,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-140.65 60.64) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 48.82,
    cy: 296.22,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-141.57 64.1) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 54.82,
    cy: 299.68,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-142.5 67.57) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 106.34,
    cy: 329.43,
    rx: 1.34,
    ry: 2.31,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -150.47, 97.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 112.34,
    cy: 332.89,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-151.4 100.78) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 118.34,
    cy: 336.36,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-152.33 104.24) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 124.34,
    cy: 339.82,
    rx: 1.34,
    ry: 2.31,
    transform: "translate(-153.26 107.71) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.82,321.83l-16.48-9.51a4.52,4.52,0,0,1-1.89-3.61h0c0-1.4.84-2,1.89-1.43l16.48,9.51a4.53,4.53,0,0,1,1.89,3.62h0C90.71,321.8,89.87,322.44,88.82,321.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M462.27,196.15,446.94,205c-1,.56-1.76,0-1.76-1.33h0a4.2,4.2,0,0,1,1.76-3.35l15.33-8.85c1-.56,1.75,0,1.75,1.33h0A4.19,4.19,0,0,1,462.27,196.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M438.79,209.71l-15.33,8.85c-1,.56-1.76,0-1.76-1.33h0a4.22,4.22,0,0,1,1.76-3.36L438.79,205c1-.56,1.75,0,1.75,1.33h0A4.2,4.2,0,0,1,438.79,209.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147.58,346.76l-124.66-72c-10.56-6.1-9.23-16.75,3-23.79L327,77.14c12.2-7,30.64-7.8,41.2-1.71l124.66,72c10.56,6.09,9.24,16.74-3,23.78L188.78,345.05C176.58,352.09,158.14,352.86,147.58,346.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M479.49,150.28l-48.67-28.1-.12.07c-5.75,3.32-15.07,3.32-20.82,0s-5.75-8.71,0-12l.12-.06-48.67-28.1c-7.39-4.27-19.38-4.27-26.77,0L41.27,251.39c-7.39,4.26-7.39,11.18,0,15.45l118.15,68.22c7.4,4.27,19.38,4.27,26.77,0L479.49,165.73C486.88,161.46,486.88,154.54,479.49,150.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.49,165.73,186.2,335.06c-6.68,3.86-17.13,4.22-24.53,1.1a18.47,18.47,0,0,1-2.23-1.1L41.28,266.84a12.48,12.48,0,0,1-4.15-3.6c-2.79-4-1.41-8.65,4.15-11.85L334.56,82.05c7.39-4.26,19.37-4.26,26.77,0L410,110.16l-.12.07c-5.75,3.32-5.75,8.69,0,12s15.08,3.33,20.82,0l.11-.06,48.68,28.1C486.88,154.55,486.88,161.46,479.49,165.73Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 417.09,
    cy: 118.08,
    rx: 5.59,
    ry: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M415.44,119a1,1,0,0,1,0-1.92,3.71,3.71,0,0,1,3.31,0,1,1,0,0,1,0,1.92A3.71,3.71,0,0,1,415.44,119Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M355.43,212.24,251.12,152c-6.06-3.5-5.3-9.61,1.7-13.65L323,97.85c7-4,17.6-4.49,23.66-1L451,157.09c6.06,3.5,5.3,9.61-1.7,13.66l-70.17,40.51C372.08,215.3,361.49,215.74,355.43,212.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "358.77 142.29 321.21 148.1 327.24 135.11 268.36 144.22 284.82 153.72 311.46 169.1 338.96 184.98 358.77 142.29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 407.03,
    cy: 160.89,
    rx: 18.63,
    ry: 10.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M248.93,273.72,144.62,213.5c-6.06-3.5-5.3-9.61,1.7-13.66l70.16-40.51c7-4,17.6-4.48,23.66-1l104.31,60.22c6.06,3.51,5.3,9.62-1.7,13.66l-70.17,40.51C265.58,276.79,255,277.22,248.93,273.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M236.25,293.72l-70.17,40.5a22.17,22.17,0,0,1-4.41,1.94,18.47,18.47,0,0,1-2.23-1.1L41.28,266.84a12.48,12.48,0,0,1-4.15-3.6,16.39,16.39,0,0,1,2.69-1.91L110,220.82c7-4,17.6-4.48,23.66-1L238,280.06C244,283.56,243.25,289.67,236.25,293.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "145.77 265.26 108.21 271.07 114.24 258.08 55.36 267.19 71.83 276.7 98.46 292.08 125.96 307.95 145.77 265.26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 194.03,
    cy: 283.87,
    rx: 18.63,
    ry: 10.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "437.13 141.35 435.02 140.13 438.55 138.09 440.66 139.31 437.13 141.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "439.96 142.98 437.84 141.76 442.78 138.91 444.9 140.13 439.96 142.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "442.78 144.61 440.66 143.39 447.72 139.31 449.84 140.53 442.78 144.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "445.6 146.24 443.49 145.02 453.37 139.31 455.49 140.53 445.6 146.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "454.78 151.54 451.49 149.64 458.07 145.83 461.37 147.73 454.78 151.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "459.17 154.07 455.88 152.17 462.47 148.37 465.76 150.27 459.17 154.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "463.56 156.61 460.27 154.71 466.86 150.9 470.15 152.81 463.56 156.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M304.32,61.06,201.14,1.49c-2.8-1.61-5.34-1.87-7.28-1h0a5.24,5.24,0,0,0-.77.43l-10.77,6,7.84,11V95.78c0,7,4.92,15.52,11,19l40.42,23.33,4.92,12.69-5.16,22.45,11.41-6.34L263.9,151l35,20.22,1.23,10.49,11.3-6.3c2.35-1,3.85-3.55,3.85-7.41V80.08C315.3,73.08,310.39,64.56,304.32,61.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M292.91,67.4,189.73,7.83c-6.06-3.5-11-.66-11,6.34v88c0,7,4.92,15.52,11,19l40.42,23.33,11.17,28.8,11.17-15.9,40.42,23.34c6.07,3.5,11,.66,11-6.34V86.42C303.89,79.42,299,70.9,292.91,67.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M263.28,96.42c-.66-8.74-5.79-17.77-12.2-21.48-4.27-2.46-8.19-2.07-10.39.92-2.18-5.57-5.93-10.34-10.14-12.77-6.41-3.7-11.54-.59-12.2,7.39a18.7,18.7,0,0,0,.39,5.7A46.12,46.12,0,0,0,225,91.81l15.7,25.52,16-7.23c3.15-1.48,5.31-4.39,6.24-8.42A15.78,15.78,0,0,0,263.28,96.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 243.83,
    cy: 211.79,
    rx: 30.8,
    ry: 17.78
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNotificationSvg);
export default __webpack_public_path__ + "static/media/Mobile_notification_SVG.03a47a073ac229b7d1bbcfc7c95eb40b.svg";
export { ForwardRef as ReactComponent };